import React, { useEffect } from 'react';
import useGroupWithPools from 'features/SpilKlub/state/useGroupWithPools';
import '../styles/group-edit.css';
import useGroupEditForm from 'features/SpilKlub/state/useGroupEditForm';
import Input from '../components/Input';
import Button from 'ui/Button';
import { serializeGroupData } from 'features/SpilKlub/server/serializers';
import Spinner from '../../../ecoui/UISpinner';
import useScreens, {
    POOL_LIST_SLUG,
} from 'features/SpilKlub/screens/useScreens';
import { NotificationManager } from 'react-notifications';
import GroupAvatar from 'features/SpilKlub/components/GroupAvatar';

import t from '../texts';

const GroupEdit = ({ entityId: groupId }) => {
    const { data, status, error } = useGroupWithPools({
        groupId,
        staleTime: 50000,
    });

    const { setScreen } = useScreens();

    let {
        setter,
        values,
        errors,
        hasErrors,
        save,
        status: formStatus,
    } = useGroupEditForm({
        defaults:
            status !== 'loading' && status !== 'error'
                ? serializeGroupData(data?.group || {}, groupId)
                : {},
    });

    const inputProps = { setter, values, errors };

    const { isLoading } = formStatus;

    useEffect(
        () => {
            if (formStatus.isSuccess) {
                NotificationManager.success(t.editGroup.updated);
                setScreen(POOL_LIST_SLUG, groupId);
            } else if (formStatus.isError) {
                NotificationManager.error(formStatus.error.message);
            }
        },
        [formStatus]
    );

    return (
        <div className={'sk-group-edit-wrapper'}>
            {status === 'loading' ? (
                <Spinner className="top-indent-md" />
            ) : status === 'error' ? (
                error
            ) : (
                <>
                    <GroupAvatar
                        groupName={data?.group?.name}
                        avatarUrl={data?.group?.avatarUrl}
                    />
                    <Input
                        {...inputProps}
                        name="groupName"
                        label="Klubnavn"
                        placeholder="Skriv Klubnavn..."
                        disabled
                    />
                    <Input
                        {...inputProps}
                        type="textArea"
                        maxLength={250}
                        name="description"
                        label="Klubinfo"
                        placeholder="Skriv Klubinfo..."
                        inputTip="Max 250 tegn"
                    />
                    <div className={'sk-edit-form-buttons'}>
                        <Button
                            lightBlue
                            onClick={() => {
                                setScreen(POOL_LIST_SLUG, groupId);
                            }}
                            className={'sk-edit-group-btn'}
                        >
                            Annuller
                        </Button>
                        <Button
                            onClick={save}
                            active
                            disabled={hasErrors}
                            className={'sk-edit-group-btn'}
                        >
                            {isLoading ? <Spinner plain /> : 'Gem'}
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default GroupEdit;
